var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 14,
    cy: 14,
    r: 14,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1125_1652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 8C12.8133 8 11.6533 8.35189 10.6666 9.01118C9.67989 9.67047 8.91085 10.6075 8.45673 11.7039C8.0026 12.8003 7.88378 14.0067 8.11529 15.1705C8.3468 16.3344 8.91825 17.4035 9.75736 18.2426C10.5965 19.0818 11.6656 19.6532 12.8295 19.8847C13.9933 20.1162 15.1997 19.9974 16.2961 19.5433C17.3925 19.0892 18.3295 18.3201 18.9888 17.3334C19.6481 16.3467 20 15.1867 20 14C20 12.4087 19.3679 10.8826 18.2426 9.75736C17.1174 8.63214 15.5913 8 14 8ZM17.9188 11.9862L12.9913 16.91L10.0813 14C9.9818 13.9005 9.92592 13.7657 9.92592 13.625C9.92592 13.4843 9.9818 13.3495 10.0813 13.25C10.1807 13.1505 10.3156 13.0947 10.4563 13.0947C10.5969 13.0947 10.7318 13.1505 10.8313 13.25L12.9988 15.4175L17.1763 11.2437C17.2255 11.1945 17.284 11.1554 17.3483 11.1288C17.4126 11.1021 17.4816 11.0884 17.5513 11.0884C17.6209 11.0884 17.6899 11.1021 17.7542 11.1288C17.8185 11.1554 17.877 11.1945 17.9263 11.2437C17.9755 11.293 18.0146 11.3515 18.0412 11.4158C18.0679 11.4801 18.0816 11.5491 18.0816 11.6187C18.0816 11.6884 18.0679 11.7574 18.0412 11.8217C18.0146 11.886 17.9755 11.9445 17.9263 11.9937L17.9188 11.9862Z",
    fill: "#35A936"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1125_1652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/Icon_success.7b5fecd355930331094dfd2e7e0a3cee.svg";
export { ForwardRef as ReactComponent };